import type { MessagingFileKind } from "@alm/domain";
import { showsInPlace, type FileLike } from "@/lib/messaging/uploads/files";

export type FileFilter = "all" | "images" | "videos" | "documents" | "audio";

export const FILE_FILTERS: ReadonlyArray<{
  value: FileFilter;
  label: string;
  kinds?: MessagingFileKind[];
}> = [
  { value: "all", label: "All" },
  { value: "images", label: "Images", kinds: ["image"] },
  { value: "videos", label: "Videos", kinds: ["video"] },
  {
    value: "documents",
    label: "Documents",
    kinds: ["pdf", "document", "text", "archive", "other"],
  },
  { value: "audio", label: "Audio", kinds: ["audio"] },
];

export const isFileFilter = (value: unknown): value is FileFilter =>
  FILE_FILTERS.some((filter) => filter.value === value);

export const kindsOf = (filter: FileFilter) =>
  FILE_FILTERS.find((entry) => entry.value === filter)?.kinds;

/** Pictures a browser draws and videos go in the grid; everything else is a row. */
export const inGrid = (file: Pick<FileLike, "kind" | "mediaType">) =>
  file.kind !== "audio" && showsInPlace(file);
